module.exports = __webpack_public_path__ + "static/media/kitchen6.038e08e3.jpg";